<template>
    <div class="check-record-wrap">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="info-wrap">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">人脸建档记录</span>
            </div>
            <div class="table-wrap">
                <el-table :data="recordList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column prop="name"
                                     width="90px"
                                     type="index"
                                     label="序号">
                    </el-table-column>
                    <el-table-column prop="accountName"
                                     min-width="100px"
                                     label="医生姓名">
                        <template slot-scope="scope">
                            {{scope.row.userName || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="hospitalLevel"
                                     min-width="90px"
                                     label="所属医院">
                        <template>
                            {{ '树兰(杭州)医院' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="departmentName"
                                     min-width="90px"
                                     label="所属科室">
                        <template slot-scope="scope">
                            {{scope.row.departmentName || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="idCard"
                                     min-width="100px"
                                     label="身份证号">
                        <template slot-scope="scope">
                            {{scope.row.idCard || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="phone"
                                     min-width="90px"
                                     label="手机号">
                        <template slot-scope="scope">
                            {{scope.row.phone || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateTime"
                                     min-width="150px"
                                     label="建档时间">
                        <template slot-scope="scope">
                            {{scope.row.updateTime || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right"
                                     min-width="60px"
                                     label="操作">
                        <template slot-scope="scope">
                            <span   v-if="scope.row.cjwdjdAccountHead"
                                    @click="showPic(scope.row.cjwdjdAccountHead)"
                                    class="link-btn">查看近照</span>
                            <span   v-else
                                    class="link-btn-none">暂无近照</span>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="pageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total"></el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible"
                   :destroy-on-close="true"
                   :show-close="false"
                   width="600px"
                   @close="clearUrl"
                   class="ww-pre-dialog">
            <img width="100%"
                 :src="dialogImageUrl"
                 alt="">
            <span slot="title">
                <el-image class="icon-delete"
                          :src="deleteUrl"
                          @click="clearUrl">
                </el-image>
            </span>
        </el-dialog>
    </div>
</template>
<style lang="scss" scoped>
.info-wrap {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    top: 50px;
    padding: 20px;
    overflow: auto;
}
.title-wrap {
    font-size: 0;
    padding-bottom: 20px;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}

.table-wrap {
    .table-none {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .icon {
            font-size: 100px;
        }
        span {
            line-height: 14px;
        }
    }
    .link-btn {
        color: $a-link;
        cursor: pointer;
        font-size: 12px;
        display: inline-block;
        height: 14px;
        line-height: 14px;
        border-right: 1px solid $a-link;
        margin-right: 6px;
        padding-right: 6px;
        &:last-child {
            border-right: none;
            margin-right: 0;
            padding-right: 0;
        }
    }
    .link-btn-none {
        color: #ccc;
        cursor: not-allowed;
    }
}
</style>
<script>
import { mapGetters } from 'vuex'
import { postFaceList } from '@/api/education'
export default {
    name: 'checkRecord',
    data () {
        return {
            breadList: [{ label: '继续教育' }, { label: '人脸建档记录' }],
            page: {
                current: 1,
                total: 0,
                pageSize: 15
            },
            recordList: [],
            loading: true,
            dialogVisible: false,
            dialogImageUrl: '',
            strUrl: '/ms-hoc-video/v1/image/download?fileName=',
            deleteUrl: require('../../../assets/imgs/delete.png')
        }
    },
    computed: {
        ...mapGetters([
            'dictionary'
        ])
    },
    methods: {
        init () {
            this.getData()
        },
        pageChange (value) {
            this.page.current = value
            this.getData()
        },
        async getData () {
            this.loading = true
            const param = {
                current: this.page.current,
                size: this.page.pageSize
            }
            const { results } = await postFaceList(param)
            this.recordList = results.records || []
            this.page.total = results.total || 0
            this.loading = false
        },
        showPic (url) {
            this.dialogImageUrl = this.strUrl + url
            this.dialogVisible = true
        },
        clearUrl () {
            this.dialogImageUrl = ''
            this.dialogVisible = false
        }
    },
    mounted () {
        this.init()
    }
}
</script>
